module.exports = __webpack_public_path__ + "img/lina.f1cd1388.png";